import Privilege1 from '@/assets/image/subscription/privilege1.png';
import Privilege2 from '@/assets/image/subscription/privilege2.png';
import Privilege3 from '@/assets/image/subscription/privilege3.png';
import Privilege4 from '@/assets/image/subscription/privilege4.png';
import Privilege5 from '@/assets/image/subscription/privilege5.png';
import Privilege6 from '@/assets/image/subscription/privilege6.png';

import Svip1 from '@/assets/image/subscription/svip1.png';
import Svip2 from '@/assets/image/subscription/svip2.png';
import Svip3 from '@/assets/image/subscription/svip3.png';
import Svip4 from '@/assets/image/subscription/svip4.png';
import Svip5 from '@/assets/image/subscription/svip5.png';
import Svip6 from '@/assets/image/subscription/svip6.png';
import Svip7 from '@/assets/image/subscription/svip7.png';

export const privilegeMap: any = {
  vip: [
    {
      icon: Privilege1,
      label: '批处理免费体验次数',
      desc: '仅限Windows客户端版本',
      type: 'web',
    },
    {
      icon: Privilege2,
      label: '会员功能',
      type: 'all',
    },
    {
      icon: Privilege3,
      label: '会员素材',
      type: 'all',
    },
    {
      icon: Privilege4,
      label: '会员特效',
      type: 'all',
    },
    {
      icon: Privilege5,
      label: '无广告',
      type: 'all',
    },
    {
      icon: Privilege6,
      label: '无美图画报',
      type: 'all',
    },
  ],
  svip: [
    {
      icon: Svip1,
      label: '特效滤镜',
    },
    {
      icon: Svip2,
      label: '增强',
    },
    {
      icon: Svip3,
      label: '面部重塑',
    },
    {
      icon: Svip4,
      label: '皮肤调整',
    },
    {
      icon: Svip5,
      label: '头部调整',
    },
    {
      icon: Svip6,
      label: '增高塑形',
    },
    {
      icon: Svip7,
      label: '边框',
    },
  ],
};

export enum PayType {
  ALIPAY = 'alipay',
  WECHAT = 'weixin',
}

export const PayTypeValue = {
  [PayType.WECHAT]: 0,
  [PayType.ALIPAY]: 1,
};

export enum ContentType {
  QRCODE = 'qrcode',
  URL = 'url',
}

// 入口分类标识

export enum EntranceBizCodeType {
  SAASMAC = 'SaaSmac_common',
  HBP = 'hbp_common',
  XIUXIUPRO = 'xiuxiu_pro.vip_center',
}

// 所属平台(1: Android 2: IOS 3: Google 4: PC/Web)

export enum PlatfromType {
  ANDROID = 1,
  IOS = 2,
  GOOGLE = 3,
  WEB = 4,
}

export enum TabType {
  // 购买会员
  SUB = 'sub',
  // 购买高级会员
  PRO_SUB = 'pro_sub',
  // 购买美豆
  MEIDOU = 'meidou',
  // 购买抠图张数
  CUTOUT = 'cutout',
  // logo无限卡
  UNLIMITED = 'unlimited',
}

/**
 * 美豆档次配置（1：1000美豆/月，2：1800美豆/月，3：3600美豆/月，4：7500美豆/月）
 */
export const GIFT_LEVEL_LIST = [
  { value: 1, label: '1000美豆/月', meidou: 1000 },
  { value: 2, label: '1800美豆/月', meidou: 1800 },
  { value: 3, label: '3600美豆/月', meidou: 3600 },
  { value: 4, label: '7500美豆/月', meidou: 7500 },
] as const;

/** 用于 Select 的 options */
export const GIFT_LEVEL_OPTIONS = GIFT_LEVEL_LIST.map(({ value, label }) => ({ value, label }));

/** giftLevel -> 每月美豆数量 */
export const GIFT_LEVEL_MEIDOU_MAP: Record<number, number> = GIFT_LEVEL_LIST.reduce((acc, item) => {
  acc[item.value] = item.meidou;
  return acc;
}, {} as Record<number, number>);

export const TABS = [
  {
    name: '标准会员',
    tag: '',
    key: TabType.SUB,
    icon: null,
  },
  {
    name: '高级会员',
    tag: '',
    key: TabType.PRO_SUB,
  },
  {
    name: '充值美豆',
    tag: '',
    key: TabType.MEIDOU,
    icon: null,
  },
];

// promotion_type优惠类型：1：推介促销-首期优惠 2：推介促销-免费试用 3：促销优惠-随用随付 4：促销优惠-免费试用 5：促销优惠-提前支付 6：买赠活动 11：推介促销-低价试用 12：促销优惠-低价试用 17：阶梯优惠
export enum PromotionType {
  /**
   * 促销优惠类型：未知
   */
  Unknown = 0,
  /**
   * 促销优惠类型：推介促销之首期优惠
   */
  RecommendedFirst = 1,
  /**
   * 促销优惠类型：推介促销之免费试用
   */
  RecommendedFreeTrial = 2,
  /**
   * 促销优惠类型：促销优惠之随用随付
   */
  SalesPayAnyTime = 3,
  /**
   * 促销优惠类型：促销优惠之免费试用
   */
  SalesFreeTrial = 4,
  /**
   * 促销优惠类型：促销优惠之提前支付
   */
  SalesPrepayment = 5,
  /**
   * 促销优惠类型：买赠
   */
  Accessory = 6,
  /**
   * 促销优惠类型：推介促销-低价试用
   */
  LowPriceTrialPromotion = 11,
  /**
   * 促销优惠类型：促销优惠-低价试用
   */
  LowPriceTrialPromotionOffers = 12,
  /**
   * 促销优惠类型：促销优惠-低价试用
   */
  TieredDiscounts = 17,
}

export enum BusinessType {
  /**
   * 大额商务咨询
   */
  LargeAmount = 1,
  /**
   * 商用咨询
   */
  Commercial = 2,
}

/**
 * 红包弹窗优惠券类型
 */
export enum RedEnvelopeType {
  /**
   *  1-商品原价折扣
   */
  DiscountOriginal = 1,
  /**
   * 2-价格优惠策略折扣
   */
  DiscountStrategy = 2,
  /**
   * 3-零元免费试用
   */
  FreeTrial = 3,
  /**
   * 4-低价试用
   */
  LowPriceTrial = 4,
}

export enum ProjectEnum {
  /**
   * pc.meitu.com站点
   */
  PcHome = 'pc-home',
}

/**
 * 会员等级枚举（接口约定：0 非会员，1/2 均为普通会员，3 高级会员）
 */
export enum VipLevel {
  /**
   * 非会员
   */
  Normal = 0,
  /**
   * 普通会员（编码 1）
   */
  Vip = 1,
  /**
   * 普通会员（编码 2，与 Vip 同级）
   */
  VipAlt = 2,
  /**
   * 高级会员
   */
  Pro = 3,
}

/** 是否为普通会员等级（1、2） */
export const isStandardVipLevel = (level?: number): boolean =>
  level === VipLevel.Vip || level === VipLevel.VipAlt;

/** 是否为高级会员（3） */
export const isProVipLevel = (level?: number): boolean => level === VipLevel.Pro;
